export const HAS_SHOWN_REFERRAL_ACTIVE_MODAL_STORAGE_KEY = "hasShownReferralActiveModal";
// deprecated
export const REFERRAL_REDEEM_CODE_STORAGE_KEY = "referralCode";
// replaces REFERRAL_REDEEM_CODE_STORAGE_KEY, can hold object
export const REFERRAL_REDEMPTION_STORAGE_KEY = "referralRedemption";
export const SHOULD_REDIRECT_TO_REFERRAL_REDEEM_CODE_STORAGE_KEY =
  "shouldRedirectToReferralRedeemCode";

export const REFERRAL_CODE_QUERY_PARAM_KEY = "code";
